import React from 'react';
import { upperCaseWordSplitAndSpace } from '../../../utils/regex.utils';

const EmptyApiDataMessage = ({ componentName = '' }) => {
  const formattedName = upperCaseWordSplitAndSpace(componentName);

  return (
    <section className="empty-api-data-message">
      <p className="empty-api-data-message__title">{formattedName} data missing</p>
    </section>
  );
};

export default EmptyApiDataMessage;
